import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import styled from '@emotion/styled';
import HexagonIcon from '@mui/icons-material/Hexagon';


const WrapperResendEmail = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap:4px;
  flex-wrap: wrap;
`;

const BtnResendEmail = styled('span')(({theme})=>`
color: ${theme.palette.primary.main};
cursor: pointer;
`);

const ItemOption = styled('li')(() => `
display: flex;
justify-content: flex-start;
align-items: center;
gap: 4px;
font-size: 14px;
@media (min-width: 600px) {
   font-size: 16px;
}
`);

const IconHexagon = styled(HexagonIcon)(({ theme }) => `
width: 16px;
height: 16px;
color: ${theme.palette.primary.main};
`);


export const RegisterModal = ({ open, onClose, userEmail, resendEmail }) => {

  const handleResend = () => {
    if (userEmail) {
      resendEmail({ email:userEmail });
    }    
  };

  return (
    <Dialog open={open}>
      <DialogTitle>Controlla la tua posta</DialogTitle>
      <DialogContent>
        <p>
          Abbiamo inviato un'email di verifica all'indirizzo <strong>{userEmail}</strong>.   
        </p>
        <p>Controlla la tua casella di posta e clicca sul bottone nell'email per verificare il tuo indirizzo.</p>
        <p><b>Non hai ancora ricevuto l'email di conferma?</b></p>
         <ul>
            <ItemOption><IconHexagon/>Controlla la cartella di posta indesiderata o spam</ItemOption>
            <ItemOption><IconHexagon/>Potrebbe volerci qualche minuto</ItemOption>            
        </ul>
        <WrapperResendEmail>     
          <p>Se il problema persiste</p>
          <BtnResendEmail onClick={handleResend}>Reinvia email di verifica</BtnResendEmail>
        </WrapperResendEmail>        
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Chiudi
        </Button>
      </DialogActions>
    </Dialog>
  );
};